import React from 'react';

import Lead from './Components/Lead';
import useLead from './useLead';

const LeadIndex: React.FC = () => {
  const leadProps = useLead();

  return <Lead />;
};
export default LeadIndex;
